import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import PortalModal from '../common/Modal/PortalModal';
import GenericButton from '../common/GenericButton';
import { CAC_MAXIMUM_PROJECT_COUNT, CAC_OPEN_SELECTED_PROJECTS_EXCEEDED_LABEL,
  CAC_NO_SAVED_PROJECTS_LABEL,
  CAC_MAX_LIMIT_REACHED_LABEL,
  CAC_MODULE_TITLE,
  CAC_LEFT_PANEL_BUILD_LABEL,
 } from './CacConstants';
import CacOpenProjectModalContent from './CacOpenProjectModalContent';

const openModalStyle = {
  width: '784px',
  height: '450px',
  left: '25%',
  top: '5%',
};

const currClusterModalStyle = {
  width: '50%',
  left: '25%',
  top: '30%',
};

function CacSaveOpenPanel({
  project, activeProjectId, openSavedProjects, savedProjects, callSaveProject, getSelectedProjects,
  noSavedProjects, handleCloseOpen, projectCount, openedProjectIds, setSelectedToActive,
  exportProject,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [limitReached, setLimitReached] = useState(false);
  const [maxLimitModal, showMaxLimitModal] = useState(false);

  const handleSave = () => {
    callSaveProject();
  };

  const handleOpen = () => {
    if (projectCount < CAC_MAXIMUM_PROJECT_COUNT) {
      openSavedProjects();
      setOpenModal(true);
    } else {
      showMaxLimitModal(true);
    }
  };

  const handleExport = () => {
    exportProject(project);
  }

  /* istanbul ignore next */
  const handleLoadProjects = selectedEntries => {
    let selectedIds = selectedEntries.map(entry => entry.id);
    const selectedCount = selectedIds.length;
    if (selectedCount > 0 && projectCount + selectedCount <= CAC_MAXIMUM_PROJECT_COUNT) {
      if (openedProjectIds.length > 0) {
        const selectedFirstProjectId = selectedIds[0];
        selectedIds = selectedEntries.filter(entry =>
          !openedProjectIds.includes(entry.id)).map(entry => entry.id);
        setLimitReached(false);
        if (selectedIds.length > 0 && selectedIds[0] === selectedFirstProjectId) {
          getSelectedProjects(selectedIds);
        } else if (selectedIds.length > 0 && selectedIds[0] !== selectedFirstProjectId) {
          getSelectedProjects(selectedIds, selectedFirstProjectId);
        } else {
          setSelectedToActive(selectedFirstProjectId);
        }
        setOpenModal(false);
      } else {
        setLimitReached(false);
        getSelectedProjects(selectedIds);
        setOpenModal(false);
      }
    } else {
      setLimitReached(true);
    }
  };

  const handleCloseOpenModal = () => {
    setOpenModal(false);
    setLimitReached(false);
    handleCloseOpen();
  };

  const isExportDisabled = () => {
    return ((project && project.leftPanel === CAC_LEFT_PANEL_BUILD_LABEL) ||
    (project && project.clusterResponse && project.clusterResponse.errMsg) ||
    (project && project.corrResponse && project.corrResponse.errMsg))
  }

  const renderListModalContent = () => {
    if (savedProjects && savedProjects.length > 0) {
      /* istanbul ignore next */
      return (<div className="large-12 columns">
        {limitReached &&
          <div className="limit-text-note">{CAC_OPEN_SELECTED_PROJECTS_EXCEEDED_LABEL}</div>}
        <CacOpenProjectModalContent
          data-test="ModalContentPopup"
          rowData={savedProjects}
          updateCrosstabTitle={() => {}}
          rowSelectionType="Multi"
          handleLoadCac={handleLoadProjects}
        />
      </div>);
    } if (savedProjects.length === 0 && noSavedProjects) {
      return (<div className="no-project-content">
        <p>{CAC_NO_SAVED_PROJECTS_LABEL}</p>
        <GenericButton
          name="Close"
          onBtnClick={handleCloseOpenModal}
        />
      </div>);
    }
    return (<div className="flex-center">Loading...</div>);
  };

  return (
    <div className="cac-open-content">
      <button
        type="button"
        className="cac-open-content-save"
        onClick={handleSave}
        disabled={activeProjectId === null}
      >
        SAVE
      </button>
      <button
        type="button"
        className="cac-open-content-open"
        onClick={handleOpen}
      >
        OPEN
      </button>
      <button
        type="button"
        className={isExportDisabled() ?
           'cac-open-content-export-disabled' :  'cac-open-content-export-enabled' }
        onClick={handleExport}
        disabled={isExportDisabled()}
      >
        EXPORT
      </button>
      <PortalModal
        isShowing={openModal}
        title="Open Saved Projects"
        // hide={() => setOpenModal(false)}
        onCloseClicked={handleCloseOpenModal}
        dialogStyles={openModalStyle}
      >
        {renderListModalContent()}
      </PortalModal>
      <PortalModal
        data-test="MaxLimitModal"
        isShowing={maxLimitModal}
        // hide={() => showMaxLimitModal(false)}
        title={CAC_MODULE_TITLE}
        dialogStyles={currClusterModalStyle}
        onCloseClicked={() => showMaxLimitModal(false)}
      >
        <p>{CAC_MAX_LIMIT_REACHED_LABEL}</p>
        <div className="text-center">
          <GenericButton
            name="Ok"
            onBtnClick={() => showMaxLimitModal(false)}
          />
        </div>
      </PortalModal>
    </div>
  );
}

CacSaveOpenPanel.propTypes = {
  project: PropTypes.shape({
    leftPanel: PropTypes.string,
    clusterResponse: PropTypes.shape({
      errMsg: PropTypes.string,
    }),
    corrResponse: PropTypes.shape({
      errMsg: PropTypes.string,
    }),
  }),
  activeProjectId: PropTypes.number,
  openSavedProjects: PropTypes.func,
  savedProjects: PropTypes.arrayOf(PropTypes.shape({})),
  callSaveProject: PropTypes.func,
  getSelectedProjects: PropTypes.func,
  noSavedProjects: PropTypes.bool,
  handleCloseOpen: PropTypes.func,
  projectCount: PropTypes.number,
  openedProjectIds: PropTypes.arrayOf(PropTypes.number),
  setSelectedToActive: PropTypes.func,
  exportProject: PropTypes.func,
};

export default memo(CacSaveOpenPanel);
